<div class="full_page_container">

  <div class="sections">
    <section class="tariff_info">
      <div class="item">
        <div class="item_header">
          Charge Name
        </div>
        <div class="item_value">
          {{ chargeName }}
        </div>
      </div>
      <div class="vertical_divider"></div>
      <div class="item">
        <div class="item_header">
          Validity
        </div>
        <div class="item_value">
          <app-svg-icon [path]="'assets/icons/calendar_icon.svg'"></app-svg-icon>
          {{ DateUtils.formatDate(tariffInfo?.fromTime) }} - {{ DateUtils.formatDate(tariffInfo?.toTime) }}
        </div>
      </div>
      <div class="vertical_divider"></div>
      <div class="item">
        <div class="item_header">
          Priority
        </div>
        <div class="item_value">
          {{ tariffInfo?.priority }}
        </div>
      </div>
      <div class="vertical_divider"></div>
      @if (tariffInfo?.agreementConfigurationId) {
        <div class="item">
          <div class="item_header">
            Customer Agreement
          </div>
          <div class="item_value">
            <a
              [routerLink]="['manage-finance/customer-agreement/??/configurations/configure/' + tariffInfo?.agreementConfigurationId]">Link</a>
          </div>
        </div>
      }
    </section>
    @if (CommonUtils.isNotNil(slabConfig?.slabSet)) {
      <section class="slab_config_section">
        <div class="applied_header">
          Applied Storage Slab Configuration
        </div>
        <div class="slab_grid">
          @for (slabSet of slabConfig?.slabSet; track $index) {
            <div class="slab_grid_item">
              <table class="slab-table" [ngClass]="{applied: tariffCalculatedResponse.slabIndex === $index}">
                <thead>
                <tr>
                  <th style="display: flex;justify-content: space-between">
                    Configurations
                    <div class="applied_pill" *ngIf="tariffCalculatedResponse.slabIndex === $index">Applied</div>
                  </th>
                  <th>From</th>
                  <th>To</th>
                  <th>Period</th>
                  <th>Amount (Per Period)</th>
                  <th>Min. Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let slab of slabSet.slabs; let i = index">
                  <td *ngIf="i === 0" [attr.rowspan]="slabSet.slabs.length" class="config-cell">
                    <div class="rules-container" *ngIf="slabSet.criteria.rules?.length > 0">
                      <div class="rule-pill" *ngFor="let rule of slabSet.criteria.rules">
                        {{ tariffService.getDisplayTextForDeterminant(rule.determinant) }}
                        {{ tariffService.getDisplayTextForOperator(rule.operator) }}
                        {{ tariffService.getValuesToPrint(rule) }}
                        <span *ngIf="rule.values.length > 3">...</span>
                      </div>
                    </div>
                  </td>
                  <td>{{ slab.from }}</td>
                  <td>{{ slab.to }}</td>
                  <td>{{ slab.chargePerPeriod }}</td>
                  <td>{{ slab.values.tariffExpression }}</td>
                  <td>{{ slab.values.minTariffExpression }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          }
        </div>
      </section>
    }
    @if (ruleSets) {
      <section class="tariff_applied_section">
        <div class="applied_header">
          Tariff Applied
        </div>
        <div class="rule_sets_container">
          @for (ruleSet of ruleSets; track $index; let ruleSetIndex = $index) {

            <div class="description_text">
              {{ ruleSet.description }}
            </div>
            <div class="table-container">

              <table class="matrix-table">
                <thead>
                <tr>
                  <th class="common_header">Rules</th>

                  <!-- Column headers with rules -->
                  <th class="col-header" *ngFor="let col of ruleSet.cols; let colIndex = index" [ngClass]="{
                'highlighted': highlightHeaders.colIndex === colIndex,
                applied: isRuleSetApplied(ruleSetIndex,undefined,colIndex)
                }">
                    <div class="header-content">
                      <div class="rules-container" *ngIf="col.rules.length > 0">
                        <div *ngFor="let rule of col.rules.slice(0, 6); let i = index" class="rule-pill">
                          {{ tariffService.getDisplayTextForDeterminant(rule?.determinant) }}
                          {{ tariffService.getDisplayTextForOperator(rule?.operator) }}
                          {{ tariffService.getValuesToPrint(rule) }}<span *ngIf="rule.values.length > 3">...</span>
                        </div>
                        <div
                          class="rule_count"
                          [appTooltip]="col.rules.slice(6)"
                          [keyToPick]="'determinant'"
                          position="bottom"
                          *ngIf="col.rules?.length > 6"
                        >
                          + {{ col.rules?.length - 6 }}
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
                </thead>

                <tbody>
                <tr *ngFor="let row of ruleSet.rows; let rowIndex = index">
                  <!-- Row headers with rules -->
                  <td class="row-header" [ngClass]="{
                  'highlighted': highlightHeaders.rowIndex === rowIndex,
                  applied: isRuleSetApplied(ruleSetIndex,rowIndex,undefined)
                    }">

                    <div class="header-content_row">

                      <div class="header_btn_rules_container">
                        <div class="rules-container" *ngIf="row.rules.length > 0">
                          <div *ngFor="let rule of row.rules.slice(0, 6); let i = index" class="rule-pill">
                            {{ tariffService.getDisplayTextForDeterminant(rule?.determinant) }}
                            {{ tariffService.getDisplayTextForOperator(rule?.operator) }}
                            {{ tariffService.getValuesToPrint(rule) }}<span *ngIf="rule.values.length > 3">...</span>
                          </div>
                          <div
                            class="rule_count"
                            [appTooltip]="row.rules.slice(6)"
                            [keyToPick]="'determinant'"
                            position="bottom"
                            *ngIf="row.rules?.length > 6"
                          >
                            + {{ row.rules?.length - 6 }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>

                  <!-- Tariff cells -->
                  <td class="tariff-cell" *ngFor="let col of ruleSet.cols; let colIndex = index"
                      [ngClass]="{
                      applied: isRuleSetApplied(ruleSetIndex,rowIndex,colIndex)
                    }"
                      (mouseover)="highLightRowAndCol(colIndex,rowIndex)" (mouseleave)="highLightRowAndCol(-1,-1)">
                    <div class="tariff-content">
                      <div class="expressions">
                        <div class="tariff-expression">
                          <div class="label">Min Tariff</div>
                          <div class="input_error_message">
                            <div>{{ ruleSet.values[rowIndex][colIndex].minTariffExpression }}</div>
                          </div>
                        </div>
                        <div class="tariff-expression">
                          <div class="label">Tariff</div>
                          <div class="input_error_message">
                            <div>{{ ruleSet.values[rowIndex][colIndex].tariffExpression }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="applied_pill" *ngIf="isRuleSetApplied(ruleSetIndex,rowIndex,colIndex)">Applied</div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          }
        </div>
      </section>
    }
  </div>
</div>
